
<div class="vertical-menu-content campaign-content colab-autoupdate fade-in-animation">
  <div class="row" id="direct-ship" style="margin: 0;">
    <div class="col-md-12 col-sm-12 no-padding">
      <h1>Envio direto das campanhas</h1>
      <p>Uma maneira de engajar seus colaboradores e ainda economizar o seu tempo é nos autorizar a enviar as campanhas diretamente para seus funcionários.</p>
      <p>Por padrão, além do usuários do perfil "Master" como você, os colaboradores cadastrados também recebem as newsletters quinzenais de engajamento, das quais cada um dos seus colaboradores tem a opção de inativar o recebimento se não quiser recebê-las. Se quiser, alterar de acordo com opções a seguir:</p><br>
      <div class="colab-checkbox">
          <input type="radio" value="all" (click)="setTypeShip('all')" [(ngModel)]="company.send_direct_email">Para todos os cadastrados<br><br>
          <input type="radio" value="onlyActives" (click)="setTypeShip('onlyActives')" [(ngModel)]="company.send_direct_email">Somente os colaboradores ativos<br><br>
          <input type="radio" value="no" (click)="setTypeShip('no')" [(ngModel)]="company.send_direct_email">Não enviar para os funcionários, somente para os administradores
      </div>

      <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>
    </div>
  </div>
</div>
